// Get Sendbird Batch Messages
export const GET_SENDBIRD_BATCH_MESSAGES_REQUEST = 'GET_SENDBIRD_BATCH_MESSAGES_REQUEST';
export const GET_SENDBIRD_BATCH_MESSAGES_DONE = 'GET_SENDBIRD_BATCH_MESSAGES_DONE';
export const GET_SENDBIRD_BATCH_MESSAGES_FAILED = 'GET_SENDBIRD_BATCH_MESSAGES_FAILED';
export const GET_SENDBIRD_BATCH_MESSAGES_RESET = 'GET_SENDBIRD_BATCH_MESSAGES_RESET';

// Operations
export const SENDBIRD_BATCH_MESSAGES_SET_PAGE = 'SENDBIRD_BATCH_MESSAGES_SET_PAGE';